import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import Loader from '../../common/Loader.js'
class ContractFileAdd extends React.Component {
  state = {
    is_saving: false,
    name: '',
    file: null,
  }

  onSave = () => {
    this.setState({ is_saving: true })

    const formData = new FormData()
    formData.append('name', this.state.name)
    formData.append('type', this.props.type)
    formData.append('reference_id', this.props.type_id)

    if (this.state.file && typeof this.state.file == 'object') {
      formData.append('file', this.state.file)
    }

    axios
      .post(Constant.getAPI() + '/admin/upload-contract-file', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((data) => {
        if (data.status === 200 && data.data) {
          Swal.fire({
            title: 'Uploaded...',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          setTimeout(() => {
            window.location.reload()
          }, 2000)
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          is_saving: false,
        })
      })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    })
  }

  handleChangeFile = ({ target: { name, files } }) => {
    this.setState({
      [name]: files[0],
    })
  }

  render() {
    return (
      <div className="row">
        <Loader
          fullPage={true}
          open={this.state.is_saving}
        />
        <div className="col-sm-12">
          <div className="card card-border-default">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group row">
                    <label className="col-2 col-form-label">Name</label>
                    <div className="col-10">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        value={this.state.name}
                        name="name"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="row">
                    <div className="col-2">File</div>
                    <div className="col-10">
                      <div className="form-group">
                        <div>
                          <input
                            type="file"
                            id="file"
                            name="file"
                            className="w-100"
                            onChange={this.handleChangeFile}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="row">
                    <div className="text-right col-6 offset-6">
                      {this.state.is_saving ? (
                        <button
                          className="btn btn-grd-disabled mr-2"
                          disabled
                        >
                          Uploading...!
                        </button>
                      ) : (
                        <>
                          <button
                            onClick={this.onSave}
                            className="btn hor-grd btn-grd-inverse offset-1"
                          >
                            <i className="ti-save"></i> Upload
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ContractFileAdd
